import * as Sentry from '@sentry/react';

/**
 * Note: Sentry initialization is now done in main.tsx
 * This file only exports helper functions for user context management
 */

/**
 * Set user context for Sentry
 * Call this when user is authenticated
 */
export function setSentryUser(user: { id: string; email?: string; username?: string }): void {
  if (import.meta.env.VITE_SENTRY_ENABLED !== 'true') {
    return;
  }

  try {
    Sentry.setUser({
      id: user.id,
      email: user.email,
      username: user.username,
    });
  } catch (error) {
    // Silently fail - don't break the app
    console.warn('Failed to set Sentry user context:', error);
  }
}

/**
 * Clear user context for Sentry
 * Call this on logout
 */
export function clearSentryUser(): void {
  if (import.meta.env.VITE_SENTRY_ENABLED !== 'true') {
    return;
  }

  try {
    Sentry.setUser(null);
  } catch (error) {
    // Silently fail
    console.warn('Failed to clear Sentry user context:', error);
  }
}

export default Sentry;
